import { render, staticRenderFns } from "./help-feedback.vue?vue&type=template&id=391dd770&scoped=true&"
import script from "./help-feedback.vue?vue&type=script&lang=ts&"
export * from "./help-feedback.vue?vue&type=script&lang=ts&"
import style0 from "./help-feedback.vue?vue&type=style&index=0&id=391dd770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391dd770",
  null
  
)

export default component.exports